// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X8wrm","index":"styles_index__mUz3Q"};